<input type="text" class="datepicker"
       ngxDaterangepickerMd
       [(ngModel)]="selected"
       (ngModelChange)="onChangeDateRange()"
       [showCustomRangeLabel]="true"
       [alwaysShowCalendars]="true"
       [ranges]="ranges"
       [linkedCalendars]="true"
       [isInvalidDate] = "isInvalidDate"
       [showClearButton]="true"
       [autoApply]="true"
       [placeholder]="'datePicker.label' | translate"/>
